(function() {
    'use strict';

    angular.module('product')
        .controller('ProductOptionGroupCreateController', ProductOptionGroupCreateController);

    ProductOptionGroupCreateController.$inject = ['$state', 'notificationSrvc', 'productOptionGroupDataSrvc', 'productOptionGroupMessagesConst', 'errorNotificationSrvc'];

    function ProductOptionGroupCreateController($state, notificationSrvc, productOptionGroupDataSrvc, productOptionGroupMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpde: [],
            name_cpen: [],
            description: [],
            group_choice: [],
            determines_paper_type: [],
            hide_in_order: [],
            nonFieldErrors: []
        };
        self.groupData = {
            name_pl: '',
            name_en: '',
            name_de: '',
            name_cpde: '',
            name_cpen: '',
            description: '',
            group_choice: '',
            determines_paper_type: '',
            hide_in_order: '',
            select_from_list: '',
        };
        self.groups = [];

        self.createGroup = createGroup;
        self.cleanErrors = cleanErrors;

        self.group_choices = [];

        activate();

        function activate() {
            getGroupChoices();
        }

        function getGroupChoices() {
            return productOptionGroupDataSrvc.groupChoiceChoices()
                .$promise.then(function(response) {
                    self.group_choices = response;
                    return response;
                });
        }

        function createGroup() {
            productOptionGroupDataSrvc.create(
                self.groupData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", productOptionGroupMessagesConst.add);
                    $state.go('layout.productOptionGroup.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

    }
})();
